import { Helmet } from 'react-helmet';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import PhoneIcon from '@mui/icons-material/Phone';
import SearchIcon from '@mui/icons-material/Search';

export const Ordering = () => {
  return (
    <div className='ordering-component'>
      <Helmet>
        <title>Ordering Your Custom Cargo Trailer</title>
        <link rel="canonical" href="https://www.pyramidcargosolutions.com/ordering" />
        <meta name="description" content="Come with all your cargo or utility trailer questions and give us a chance to turn your dreams into reality."></meta>
      </Helmet>
      <Box 
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center">
        <h2>How to Order With Us</h2>
        <List >
            <ListItem>
            </ListItem>
            <ListItem>
              <ListItemButton href="/products">
                <ListItemIcon>
                  <SearchIcon />
                </ListItemIcon>
                <ListItemText primary="Browse Our Product Page For Ideas! Contact Us To See If The Trailer Is Available - If So, Come On By!" />
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton>
                <ListItemIcon>
                  <DriveEtaIcon />
                </ListItemIcon>
                <ListItemText primary="Have Another Idea For What You Want? We Can Custom Order Your Trailer Down To The Last Screw!" />
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton href="/financing">
                <ListItemIcon>
                  <AttachMoneyIcon />
                </ListItemIcon>
                <ListItemText primary="Determine How You Will Finance Your Dream Purchase" />
              </ListItemButton>
            </ListItem>
            <ListItem>
              <ListItemButton>
                <ListItemIcon>
                  <PhoneIcon />
                </ListItemIcon>
                <ListItemText primary="Contact Us By Email, Phone, or Text For More Information Or To Get Your Quote Started!" />
              </ListItemButton>
            </ListItem>
        </List>
      </Box>
    </div>
  )
}

export default Ordering;